import React from "react";
import style from "./RecipeBanner.module.css";
import { convertToReadableTime } from "../../Utils/helper";

export default function RecipeBanner({ chefDetails, recipe }) {
  // The API returns null (not undefined) for recipes without a chef, so
  // default parameters alone don't protect the property reads below.
  chefDetails = chefDetails || {};
  recipe = recipe || {};
  // Format view count to display with 'K' for thousands
  const formatViewCount = (count) => {
    if (count >= 1000) return `${Math.floor(count / 1000)}K`;
    return count || 0;
  };

  const formatAddedDate = () => recipe.added_date || "Recently";

  // Map API diet types ("veg" | "nonveg" | "contains_egg") to a colour class
  const dietClass =
    recipe.diet_type === "nonveg"
      ? style.nonveg
      : recipe.diet_type === "contains_egg"
        ? style.mix
        : style.veg;

  const category = recipe.category || recipe.cuisine;
  const calories = recipe.calories || recipe.kCal;

  return (
    <article className={style.card}>
      <div className={style.media}>
        {recipe.banner ? (
          <img src={recipe.banner} className={style.img} alt={recipe.title} loading="lazy" />
        ) : (
          <div className={style.imgFallback} aria-hidden="true" />
        )}

        <div className={style.mediaTop}>
          {recipe.preparation_time && (
            <span className={style.timeBadge}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="13" r="8" />
                <path d="M12 9v4l2 2M9 2h6" strokeLinecap="round" />
              </svg>
              {convertToReadableTime(recipe.preparation_time)}
            </span>
          )}
          <span className={style.save} aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 21l-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" strokeLinejoin="round" />
            </svg>
          </span>
        </div>

        {category && <span className={style.cat}>{category}</span>}
      </div>

      <div className={style.body}>
        <h3 className={style.title}>{recipe.title}</h3>

        <div className={style.chef}>
          {chefDetails.image ? (
            <img
              src={chefDetails.image}
              className={style.chefImg}
              alt={`${chefDetails.first_name || ""} ${chefDetails.last_name || ""}`}
            />
          ) : (
            <span className={style.chefImgFallback} aria-hidden="true" />
          )}
          <span className={style.chefName}>
            {chefDetails.prefix ? `${chefDetails.prefix} ` : ""}
            {chefDetails.first_name} {chefDetails.last_name}
          </span>
          <span className={`${style.dietDot} ${dietClass}`} aria-hidden="true" />
        </div>

        <div className={style.meta}>
          <span>
            {formatViewCount(recipe.view_count)} views · {formatAddedDate()}
          </span>
          {calories ? (
            <span className={style.cal}>🔥 {calories} kcal</span>
          ) : null}
        </div>
      </div>
    </article>
  );
}
